import {CookieService} from '../services/cookie.service';

/**
 * This class is responsible for catching the params from the URL and storing them in a cookie.
 * !IMPORTANT this class is also imported in the b2b project, so changer will affect both projects.
 */
export class QueryToCookieCatcher {
    static readonly PARAMS = [
        // todo (if needed): turn into config with defining the name of cookie field and option to override or not the existing value
        //  for now it always saves cookie param with the same name and overrides the value if new is present.
        'gclid',
        'msclkid',
    ];

    public static saveAll(): void {
        const urlParams = new URLSearchParams(window.location.search);
        QueryToCookieCatcher.PARAMS.forEach(function (paramName) {
            let newValue = urlParams.get(paramName);
            if (newValue) {
                CookieService.setCookie(paramName, newValue, 365);
            }
        });
    }
}

window.addEventListener('load', (event) => {
    QueryToCookieCatcher.saveAll();
});
